import { useSkuSelector } from '../hooks/useSkuSelector';

type ValueWrapperProps = {
	children: React.ReactNode;
	additionalClasses: string;
};

const ValueWrapper = ({ children, additionalClasses }: ValueWrapperProps) => {
	const { blockClass, handles, prodSum } = useSkuSelector();

	const renderClass = () => blockClass && `vtex-store-components-3-x-valueWrapper--${blockClass}`;

	return (
		<div
			className={`${prodSum ? handles.valueWrapper : ''} valueWrapper valueWrapper--${blockClass} vtex-store-components-3-x-valueWrapper ${renderClass()} ${additionalClasses}`}
		>
			{children}
		</div>
	);
};

export default ValueWrapper;
